export enum ValidationMode {
    NONE = 'NONE',      // no validation needs to be done other than logical issues
    QUOTE = 'QUOTE',    // show violations that prevent quoting
    SUBMIT = 'SUBMIT'   // show violations that prevent submission
}
